<template>
  <div>
    <div class="pb-6 pt-6">
      <div class="px-0 mx-auto prose">
        <h1 class="text-center text-decoration-underline" >Keyboard Shortcuts</h1>
        <br>
        <div class="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Command</th>
                <th>Windows/Linux</th>
                <th>macOS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Copy</td>
                <td><code>Control</code>&nbsp;<code>C</code></td>
                <td><code>Cmd</code>&nbsp;<code>C</code></td>
              </tr>
              <tr>
                <td>Cut</td>
                <td><code>Control</code>&nbsp;<code>X</code></td>
                <td><code>Cmd</code>&nbsp;<code>X</code></td>
              </tr>
              <tr>
                <td>Paste</td>
                <td><code>Control</code>&nbsp;<code>V</code></td>
                <td><code>Cmd</code>&nbsp;<code>V</code></td>
              </tr>
              <tr>
                <td>Paste without formatting</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >V</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>V</code>
                </td>
              </tr>
              <tr>
                <td>Undo</td>
                <td><code>Control</code>&nbsp;<code>Z</code></td>
                <td><code>Cmd</code>&nbsp;<code>Z</code></td>
              </tr>
              <tr>
                <td>Redo</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >Z</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>Z</code>
                </td>
              </tr>
              <tr>
                <td>Add a line break</td>
                <td><code>Shift</code>&nbsp;<code>Enter</code></td>
                <td><code>Shift</code>&nbsp;<code>Enter</code></td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>
          <a
            id="text-formatting"
            href="#text-formatting"
            class="anchor-link"
            aria-hidden="true"
            title="Permalink"
            >#</a
          >Text Formatting
        </h3>
        <div class="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Command</th>
                <th>Windows/Linux</th>
                <th>macOS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Bold</td>
                <td><code>Control</code>&nbsp;<code>B</code></td>
                <td><code>Cmd</code>&nbsp;<code>B</code></td>
              </tr>
              <tr>
                <td>Italicize</td>
                <td><code>Control</code>&nbsp;<code>I</code></td>
                <td><code>Cmd</code>&nbsp;<code>I</code></td>
              </tr>
              <tr>
                <td>Underline</td>
                <td><code>Control</code>&nbsp;<code>U</code></td>
                <td><code>Cmd</code>&nbsp;<code>U</code></td>
              </tr>
              <tr>
                <td>Strikethrough</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >X</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>X</code>
                </td>
              </tr>
              <tr>
                <td>Highlight</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >H</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>H</code>
                </td>
              </tr>
              <tr>
                <td>Code</td>
                <td><code>Control</code>&nbsp;<code>E</code></td>
                <td><code>Cmd</code>&nbsp;<code>E</code></td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>
          <a
            id="paragraph-formatting"
            href="#paragraph-formatting"
            class="anchor-link"
            aria-hidden="true"
            title="Permalink"
            >#</a
          >Paragraph Formatting
        </h3>
        <div class="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Command</th>
                <th>Windows/Linux</th>
                <th>macOS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Apply normal text style</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>0</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>0</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 1</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>1</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>1</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 2</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>2</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>2</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 3</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>3</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>3</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 4</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>4</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>4</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 5</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>5</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>5</code>
                </td>
              </tr>
              <tr>
                <td>Apply heading style 6</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>6</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>6</code>
                </td>
              </tr>
              <tr>
                <td>Ordered list</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >7</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>7</code>
                </td>
              </tr>
              <tr>
                <td>Bullet list</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >8</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>8</code>
                </td>
              </tr>
              <tr>
                <td>Task list</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >9</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>9</code>
                </td>
              </tr>
              <tr>
                <td>Blockquote</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >B</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>B</code>
                </td>
              </tr>
              <tr>
                <td>Left align</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >L</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>L</code>
                </td>
              </tr>
              <tr>
                <td>Center align</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >E</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>E</code>
                </td>
              </tr>
              <tr>
                <td>Right align</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >R</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>R</code>
                </td>
              </tr>
              <tr>
                <td>Justify</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >J</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>J</code>
                </td>
              </tr>
              <tr>
                <td>Code block</td>
                <td>
                  <code>Control</code>&nbsp;<code>Alt</code>&nbsp;<code>C</code>
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Alt</code>&nbsp;<code>C</code>
                </td>
              </tr>
              <tr>
                <td>Subscript</td>
                <td><code>Control</code>&nbsp;<code>,</code></td>
                <td><code>Cmd</code>&nbsp;<code>,</code></td>
              </tr>
              <tr>
                <td>Superscript</td>
                <td><code>Control</code>&nbsp;<code>.</code></td>
                <td><code>Cmd</code>&nbsp;<code>.</code></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--| Toggle task| `Control`&nbsp;`Enter` | `Cmd`&nbsp;`Enter` | -->
        <h3>
          <a
            id="text-selection"
            href="#text-selection"
            class="anchor-link"
            aria-hidden="true"
            title="Permalink"
            >#</a
          >Text Selection
        </h3>
        <div class="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Command</th>
                <th>Windows/Linux</th>
                <th>macOS</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Select all</td>
                <td><code>Control</code>&nbsp;<code>A</code></td>
                <td><code>Cmd</code>&nbsp;<code>A</code></td>
              </tr>
              <tr>
                <td>Extend selection one character to left</td>
                <td><code>Shift</code>&nbsp;<code>←</code></td>
                <td><code>Shift</code>&nbsp;<code>←</code></td>
              </tr>
              <tr>
                <td>Extend selection one character to right</td>
                <td><code>Shift</code>&nbsp;<code>→</code></td>
                <td><code>Shift</code>&nbsp;<code>→</code></td>
              </tr>
              <tr>
                <td>Extend selection one line up</td>
                <td><code>Shift</code>&nbsp;<code>↑</code></td>
                <td><code>Shift</code>&nbsp;<code>↑</code></td>
              </tr>
              <tr>
                <td>Extend selection one line down</td>
                <td><code>Shift</code>&nbsp;<code>↓</code></td>
                <td><code>Shift</code>&nbsp;<code>↓</code></td>
              </tr>
              <tr>
                <td>Extend selection to the beginning of the document</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >↑</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>↑</code>
                </td>
              </tr>
              <tr>
                <td>Extend selection to the end of the document</td>
                <td>
                  <code>Control</code>&nbsp;<code>Shift</code>&nbsp;<code
                    >↓</code
                  >
                </td>
                <td>
                  <code>Cmd</code>&nbsp;<code>Shift</code>&nbsp;<code>↓</code>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
